import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IDefaultDeadline, ICustomDeadline, ICustomDeadlineUpdate } from '@settings/models';
import { Endpoint } from '@app/constants/endpoints.constants';

@Injectable({
  providedIn: 'root'
})
export class CustomDeadlineRepoService {
  constructor(private _httpClient: HttpClient) {}

  getCustomDeadline(selectedMonth: { year: string; month: string }): Observable<ICustomDeadline> {
    return this._httpClient.get<ICustomDeadline>(Endpoint.CustomDeadline, { params: selectedMonth });
  }

  patchCustomDeadline(customDeadlineDate: ICustomDeadlineUpdate): Observable<undefined> {
    const params = new HttpParams()
      .set('year', customDeadlineDate.year)
      .set('month', customDeadlineDate.month)
      .set('set-default-deadline', customDeadlineDate.restoredDefaultDeadline.toString());

    return this._httpClient.patch<undefined>(
      Endpoint.CustomDeadline,
      { dateTime: customDeadlineDate.dateTime },
      {
        params
      }
    );
  }

  getRestoredDeadline(selectedMonth: { year: string; month: string }): Observable<ICustomDeadline> {
    return this._httpClient.get<ICustomDeadline>(Endpoint.CustomDeadline + Endpoint.RestoreDeadline, {
      params: selectedMonth
    });
  }
}
